var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46392 1.18559L6.99992 5.72159L11.5173 1.20426C11.5964 1.12 11.6918 1.05259 11.7976 1.00608C11.9035 0.959568 12.0176 0.934914 12.1333 0.933594C12.3808 0.933594 12.6182 1.03193 12.7932 1.20696C12.9683 1.38199 13.0666 1.61939 13.0666 1.86693C13.0688 1.98136 13.0475 2.09502 13.0042 2.20095C12.9609 2.30688 12.8963 2.40283 12.8146 2.48293L8.25059 7.00026L12.8146 11.5643C12.9684 11.7148 13.0586 11.9185 13.0666 12.1336C13.0666 12.3811 12.9683 12.6185 12.7932 12.7936C12.6182 12.9686 12.3808 13.0669 12.1333 13.0669C12.0143 13.0719 11.8956 13.052 11.7848 13.0086C11.6739 12.9652 11.5733 12.8993 11.4893 12.8149L6.99992 8.27893L2.47326 12.8056C2.3944 12.8871 2.30018 12.9521 2.19606 12.9969C2.09193 13.0418 1.97996 13.0656 1.86659 13.0669C1.61906 13.0669 1.38166 12.9686 1.20662 12.7936C1.03159 12.6185 0.933257 12.3811 0.933257 12.1336C0.931081 12.0192 0.952312 11.9055 0.995646 11.7996C1.03898 11.6936 1.1035 11.5977 1.18526 11.5176L5.74926 7.00026L1.18526 2.43626C1.03143 2.28577 0.941228 2.08198 0.933257 1.86693C0.933257 1.61939 1.03159 1.38199 1.20662 1.20696C1.38166 1.03193 1.61906 0.933594 1.86659 0.933594C2.09059 0.936394 2.30526 1.02693 2.46392 1.18559Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b09f219e00291252657a3f8a4bbc254c.svg";
export { ForwardRef as ReactComponent };